import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { reviews } from '@/mocks/articles';

export default function About() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus('success');
      setFormMessage('投稿已提交，我们的团队将在24小时内审核回复！');
      form.reset();
      return;
    }

    setFormStatus('submitting');

    try {
      const formData = new URLSearchParams();
      formData.append('name', (form.querySelector('[name="name"]') as HTMLInputElement)?.value || '');
      formData.append('email', (form.querySelector('[name="email"]') as HTMLInputElement)?.value || '');
      formData.append('tip_type', (form.querySelector('[name="tip_type"]') as HTMLSelectElement)?.value || '');
      formData.append('message', (form.querySelector('[name="message"]') as HTMLTextAreaElement)?.value || '');

      await fetch('https://readdy.ai/api/form/d917o804jh3v1cgkssj0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });

      setFormStatus('success');
      setFormMessage('投稿已提交，我们的团队将在24小时内审核回复！');
      form.reset();
    } catch {
      setFormStatus('error');
      setFormMessage('提交失败，请稍后重试或直接发送邮件至 tips@sjd360.cn');
    }
  };

  return (
    <>
      <Navbar />

      <main>
        {/* Brand Introduction */}
        <section className="pt-24 pb-16 md:pb-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <p className="text-sm text-primary-500 font-medium mb-3">关于吃瓜爆料</p>
            <h1 className="font-heading text-4xl md:text-6xl font-bold text-foreground-950 leading-tight mb-8">
              真实爆料平台
              <br />
              深度追踪团队
              <br />
              娱乐纪检委
            </h1>

            <div className="flex flex-wrap gap-4 mb-10">
              <a href="#contact" className="px-8 py-3 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                立即投稿爆料
              </a>
              <a href="#reviews" className="px-8 py-3 rounded-full text-sm font-semibold border-2 border-foreground-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                查看用户评价
              </a>
            </div>

            <div className="prose max-w-none">
              <p className="text-lg text-foreground-700 leading-relaxed mb-6">
                吃瓜爆料网成立于2024年，是国内领先的娱乐圈内幕追踪与爆料平台。我们拥有一支专业的深度追踪团队，7x24小时不间断监控娱乐圈动态，第一时间为"吃瓜群众"带来最真实、最劲爆的爆料内容。
              </p>
              <p className="text-lg text-foreground-700 leading-relaxed mb-6">
                我们的使命是<strong>打破信息壁垒，让每一个爱吃瓜的人都能吃到真瓜</strong>。在这个信息爆炸的时代，谣言和假消息满天飞，吃瓜爆料网坚持真实爆料原则，所有内容均经过团队多轮核实后才发布。
              </p>
              <p className="text-lg text-foreground-700 leading-relaxed mb-6">
                目前，吃瓜爆料网日均访问量已突破<strong>50万</strong>，累计爆料超过<strong>2000篇</strong>。我们的读者遍布全国各地，从普通吃瓜群众到娱乐圈从业者，都认可吃瓜爆料网的权威性和时效性。
              </p>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-12 bg-background-100">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
              <div>
                <p className="font-heading text-4xl md:text-5xl font-bold text-primary-500 mb-2">2000+</p>
                <p className="text-sm text-foreground-500">累计爆料</p>
              </div>
              <div>
                <p className="font-heading text-4xl md:text-5xl font-bold text-accent-500 mb-2">50万+</p>
                <p className="text-sm text-foreground-500">日均访问</p>
              </div>
              <div>
                <p className="font-heading text-4xl md:text-5xl font-bold text-primary-500 mb-2">98.7%</p>
                <p className="text-sm text-foreground-500">真实率</p>
              </div>
              <div>
                <p className="font-heading text-4xl md:text-5xl font-bold text-accent-500 mb-2">24h</p>
                <p className="text-sm text-foreground-500">极速追踪</p>
              </div>
            </div>
          </div>
        </section>

        {/* Reviews */}
        <section id="reviews" className="py-16 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <p className="text-sm text-foreground-400 font-medium mb-2">用户评价</p>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
                瓜友怎么说
              </h2>
              <p className="text-foreground-500 text-sm md:text-base">
                来自真实用户的评价，吃瓜群众的真实心声
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {reviews.map((review, idx) => (
                <div key={idx} className="bg-background-100 rounded-xl p-6 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-sm ${i < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                  <blockquote className="text-foreground-700 text-sm leading-relaxed mb-4 italic">
                    &ldquo;{review.content}&rdquo;
                  </blockquote>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 text-xs font-bold">
                      {review.name.charAt(0)}
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{review.name}</p>
                      <p className="text-xs text-foreground-400">{review.date}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <section id="contact" className="py-16 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
                有料要爆？联系我们
              </h2>
              <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
                我们提供匿名投稿通道，专业团队核实后发布。你的爆料，可能成为明天的头条！
              </p>
            </div>

            <form
              data-readdy-form=""
              onSubmit={handleSubmit}
              className="max-w-xl mx-auto bg-background-50 rounded-xl p-8 border border-background-200/70"
            >
              <div className="mb-5">
                <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  你的昵称
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  placeholder="可以匿名填写"
                  className="w-full px-4 py-3 rounded-lg border border-background-300 bg-background-50 text-foreground-900 text-sm placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                />
              </div>

              <div className="mb-5">
                <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  联系邮箱 <span className="text-primary-500">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  placeholder="方便我们回复你"
                  className="w-full px-4 py-3 rounded-lg border border-background-300 bg-background-50 text-foreground-900 text-sm placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                />
              </div>

              <div className="mb-5">
                <label htmlFor="tip_type" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  爆料类型
                </label>
                <select
                  id="tip_type"
                  name="tip_type"
                  required
                  className="w-full px-4 py-3 rounded-lg border border-background-300 bg-background-50 text-foreground-900 text-sm focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                >
                  <option value="">请选择类型</option>
                  <option value="明星塌房">明星塌房</option>
                  <option value="网红翻车">网红翻车</option>
                  <option value="综艺内幕">综艺内幕</option>
                  <option value="其他爆料">其他爆料</option>
                </select>
              </div>

              <div className="mb-6">
                <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  爆料内容 <span className="text-primary-500">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows={5}
                  maxLength={500}
                  placeholder="请详细描述你想爆料的内容，越详细越好..."
                  className="w-full px-4 py-3 rounded-lg border border-background-300 bg-background-50 text-foreground-900 text-sm placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                ></textarea>
                <p className="text-xs text-foreground-400 mt-1">最多500字</p>
              </div>

              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                className="honeypot-field"
              />

              <button
                type="submit"
                disabled={formStatus === 'submitting'}
                className="w-full py-3.5 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              >
                {formStatus === 'submitting' ? (
                  <>
                    <i className="ri-loader-4-line animate-spin"></i>
                    提交中...
                  </>
                ) : (
                  <>
                    提交爆料
                    <i className="ri-send-plane-line"></i>
                  </>
                )}
              </button>

              {formStatus === 'success' && (
                <p className="mt-4 text-sm text-accent-600 text-center bg-accent-50 rounded-lg py-3 px-4">
                  <i className="ri-checkbox-circle-line mr-1"></i>
                  {formMessage}
                </p>
              )}

              {formStatus === 'error' && (
                <p className="mt-4 text-sm text-primary-600 text-center bg-primary-50 rounded-lg py-3 px-4">
                  <i className="ri-error-warning-line mr-1"></i>
                  {formMessage}
                </p>
              )}
            </form>
          </div>
        </section>

        {/* Trust Strip */}
        <section className="py-10 bg-background-50 border-t border-background-200/60">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <p className="text-center text-sm text-foreground-400 mb-6">合作媒体与平台</p>
            <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
              <span className="text-foreground-300 font-heading text-xl font-bold opacity-50">新浪娱乐</span>
              <span className="text-foreground-300 font-heading text-xl font-bold opacity-50">腾讯新闻</span>
              <span className="text-foreground-300 font-heading text-xl font-bold opacity-50">网易娱乐</span>
              <span className="text-foreground-300 font-heading text-xl font-bold opacity-50">搜狐娱乐</span>
              <span className="text-foreground-300 font-heading text-xl font-bold opacity-50">凤凰网</span>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
